"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VMFunctionSelector = void 0;
const inversify_1 = require("inversify");
const estraverse = __importStar(require("@javascript-obfuscator/estraverse"));
const ServiceIdentifiers_1 = require("../container/ServiceIdentifiers");
const IOptions_1 = require("../interfaces/options/IOptions");
const IRandomGenerator_1 = require("../interfaces/utils/IRandomGenerator");
const NodeGuards_1 = require("../node/NodeGuards");
const NodeMetadata_1 = require("../node/NodeMetadata");
let VMFunctionSelector = class VMFunctionSelector {
    constructor(randomGenerator, options) {
        this.allowListSet = null;
        this.denyListSet = null;
        this.randomGenerator = randomGenerator;
        this.options = options;
    }
    shouldVirtualize(functionNode) {
        var _a;
        if (!this.options.vmObfuscation) {
            return false;
        }
        if ((_a = functionNode.metadata) === null || _a === void 0 ? void 0 : _a.ignoredNode) {
            return false;
        }
        const functionName = this.getFunctionName(functionNode);
        if (functionName && this.isDenied(functionName)) {
            return false;
        }
        if (this.getAllowListSet().size > 0) {
            if (!functionName || !this.isAllowed(functionName)) {
                return false;
            }
        }
        if (!this.passesThreshold()) {
            return false;
        }
        if (!this.isSuitableForVirtualization(functionNode)) {
            return false;
        }
        return true;
    }
    isAllowed(functionName) {
        const allowList = this.getAllowListSet();
        if (allowList.size === 0) {
            return true;
        }
        return allowList.has(functionName);
    }
    isDenied(functionName) {
        return this.getDenyListSet().has(functionName);
    }
    passesThreshold() {
        return this.randomGenerator.getMathRandom() <= this.options.vmObfuscationThreshold;
    }
    getFunctionName(functionNode) {
        if (NodeGuards_1.NodeGuards.isFunctionDeclarationNode(functionNode) && functionNode.id) {
            return functionNode.id.name;
        }
        if (NodeGuards_1.NodeGuards.isFunctionExpressionNode(functionNode) && functionNode.id) {
            return functionNode.id.name;
        }
        return null;
    }
    isSuitableForVirtualization(functionNode) {
        if (NodeGuards_1.NodeGuards.isBlockStatementNode(functionNode.body)) {
            if (functionNode.body.body.length === 0) {
                return false;
            }
        }
        if (this.containsDirectEval(functionNode.body)) {
            return false;
        }
        return true;
    }
    containsDirectEval(node) {
        let foundDirectEval = false;
        estraverse.traverse(node, {
            enter: (currentNode) => {
                if (NodeGuards_1.NodeGuards.isCallExpressionNode(currentNode) &&
                    NodeGuards_1.NodeGuards.isIdentifierNode(currentNode.callee) &&
                    currentNode.callee.name === 'eval') {
                    foundDirectEval = true;
                    return estraverse.VisitorOption.Break;
                }
                if (NodeMetadata_1.NodeMetadata.isEvalHostNode(currentNode)) {
                    foundDirectEval = true;
                    return estraverse.VisitorOption.Break;
                }
                if (currentNode !== node &&
                    (NodeGuards_1.NodeGuards.isFunctionDeclarationNode(currentNode) ||
                        NodeGuards_1.NodeGuards.isFunctionExpressionNode(currentNode) ||
                        NodeGuards_1.NodeGuards.isArrowFunctionExpressionNode(currentNode))) {
                    return estraverse.VisitorOption.Skip;
                }
            }
        });
        return foundDirectEval;
    }
    getAllowListSet() {
        if (this.allowListSet === null) {
            this.allowListSet = new Set(this.options.vmTargetFunctions || []);
        }
        return this.allowListSet;
    }
    getDenyListSet() {
        if (this.denyListSet === null) {
            this.denyListSet = new Set(this.options.vmExcludeFunctions || []);
        }
        return this.denyListSet;
    }
};
exports.VMFunctionSelector = VMFunctionSelector;
exports.VMFunctionSelector = VMFunctionSelector = __decorate([
    (0, inversify_1.injectable)(),
    __param(0, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IRandomGenerator)),
    __param(1, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IOptions)),
    __metadata("design:paramtypes", [typeof (_a = typeof IRandomGenerator_1.IRandomGenerator !== "undefined" && IRandomGenerator_1.IRandomGenerator) === "function" ? _a : Object, typeof (_b = typeof IOptions_1.IOptions !== "undefined" && IOptions_1.IOptions) === "function" ? _b : Object])
], VMFunctionSelector);
